module.exports = __webpack_public_path__ + "static/img/product12.4d3c06e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product12.png
// module id = jpAU
// module chunks = 13